const fallbackLocale = 'fr';

export default {
  locale: document.documentElement.lang,
  fallbackLocale,
};
